import React from 'react';
import {
    ArrowDown,
    BodySmallRegular,
    Icon,
    PanelBottomDashed,
    View,
    XStack,
} from 'smoothie';

export const CreditCardRateCalloutWidget = () => {
    return (
        <View backgroundColor="$peachLight" borderRadius={12} padding={12}>
            <XStack gap={8} alignItems="flex-start" justifyContent="center">
                <View flexShrink={0} position="relative">
                    <View
                        position="absolute"
                        left="calc(50% - 5px)"
                        top={2}
                        padding={0}
                        backgroundColor="$peachLight"
                    >
                        <Icon icon={ArrowDown} size={10} />
                    </View>
                    <Icon icon={PanelBottomDashed} size={24} />
                </View>
                <BodySmallRegular fontStyle="italic" flex={1}>
                    Credit card rates like these aren&apos;t fixed — and
                    bringing them down is one of the first things Fruitful can
                    help you with.
                </BodySmallRegular>
            </XStack>
        </View>
    );
};
